;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const capitalizePlaceName = (str: string): string => {
  // First character should be uppercase
  let res = str.charAt(0).toUpperCase() + str.slice(1);

  // Then each character after a hyphen should be uppercase e.g. Sint-Truiden
  for (let i = 1; i < res.length; i += 1)
    if (res[i] === '-') res = res.slice(0, i + 1) + res.charAt(i + 1).toUpperCase() + res.slice(i + 2);

  return res;
};

export default capitalizePlaceName;
